module.exports = {
      id: "Timer-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/landing/sprite.svg#Timer-usage",
      toString: function () {
        return this.url;
      }
    }